var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExcavator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "64px",
    height: "64px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ff8e25",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(4,4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58,32h-0.81l1.55,-24.01c0.14,-2.16 -1.58,-3.99 -3.74,-3.99c-1.82,0 -3.31,1.3 -3.66,3h-12.26c-1.41,0 -2.71,0.74 -3.43,1.96l-5.38,9.04h-5.44c-1.01,0 -1.86,0.75 -1.98,1.75l-1.53,12.25h-15.32c-1.1,0 -2,0.9 -2,2v8c0,1.1 0.9,2 2,2h13v4h-5c-1.66,0 -3.16,0.67 -4.24,1.76c-1.09,1.08 -1.76,2.58 -1.76,4.24c0,3.31 2.69,6 6,6h32c1.66,0 3.16,-0.67 4.24,-1.76c1.09,-1.08 1.76,-2.58 1.76,-4.24c0,-3.31 -2.69,-6 -6,-6h-5v-4h0.87c1.1,0 2,-0.9 2,-2v-10.13l-2.85,-11.39l3.65,-9.48h6.78l1.35,21h-0.58c-0.67,0 -1.15,0.65 -0.96,1.29c0.37,1.22 0.52,2.29 0.52,4.03c0,1.74 -0.28,3.19 -2.59,5.57h4.25c3.62,0 6.55,-2.93 6.55,-6.55v-2.35c0,-1.1 -0.9,-2 -2,-2zM19.33,56c-1.1,0 -2,-0.9 -2,-2c0,-1.1 0.9,-2 2,-2c1.1,0 2,0.9 2,2c0,1.1 -0.89,2 -2,2zM30,56c-1.1,0 -2,-0.9 -2,-2c0,-1.1 0.9,-2 2,-2c1.1,0 2,0.9 2,2c0,1.1 -0.9,2 -2,2zM42.67,54c0,1.1 -0.9,2 -2,2c-1.1,0 -2,-0.9 -2,-2c0,-1.1 0.89,-2 2,-2c1.11,0 2,0.9 2,2zM26.6,22h10.68l0.71,2.84l1.79,7.16h-14.43zM25.35,35h4c0.55,0 1,0.45 1,1c0,0.55 -0.45,1 -1,1h-4c-0.55,0 -1,-0.45 -1,-1c0,-0.55 0.45,-1 1,-1zM12,40h-4v-4h4zM17,40c0,0.55 -0.45,1 -1,1c-0.55,0 -1,-0.45 -1,-1v-4c0,-0.55 0.45,-1 1,-1c0.55,0 1,0.45 1,1z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcavator);
export default __webpack_public_path__ + "static/media/excavator.7e21d9de47692247e81185029c89cb0a.svg";
export { ForwardRef as ReactComponent };